import React from 'react';
import orderActions from '../../../redux/futures/order/actions';
import storeActions from '../../../redux/futures/store/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import Spinner from '../../../components/Spinner';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import * as types from '../../../redux/futures/order/types';
import * as storeTypes from '../../../redux/futures/store/types';
import AddCommission from './AddCommission';
import Cancel from './Cancel';

class Detail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            order: {
                ladi_uid: '',
                _id: '',
                reference_no: '',
                discount: '',
                total: '',
                note: '',
                status: ''
            },
            currentStore: {},
            details: []
        }
    }

    // componentDidMount() {
    //     this.getDetail();
    // }

    componentDidUpdate() {
        window.LadiUI.init();
    }


    componentWillReceiveProps(nextProps) {


        if (this.props.currentPayment !== nextProps.currentPayment) {
            this.setState({
                order: _.pick(nextProps.currentPayment, _.keys(this.state.order))
            })
        }

        if (_.includes([types.DETAIL_ORDER], nextProps.action)) {
            if (nextProps.status) {

                this.setState({
                    details: nextProps.details,
                    currentStore: nextProps.user,
                    // order: nextProps.order
                });
            } else {
            }
        }
    }
    cancel = (currentOrder) => {

        this.props.getListPackage();
    }
    render() {
        const { details, order, currentStore } = this.state;
        const { affilate } = details;
        // console.log('currentStore:', currentStore);
        return (
            <div id="modal-detail" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-detail">
                <div className="ladiui-modal-content" style={{ maxWidth: '1200px', overflow: 'scroll', maxHeight: '100vh' }}>
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-detail"><i className="ladi-icon icon-e-remove" data-dismiss="modal-detail" /></button>

                        {
                            (!order.credit_used || order.credit_used == 0) &&
                            <button className="ladiui button primary open-modal" modal="modal-add-commission" >Tạo commission affiliate</button>
                        }
                        {
                            order.credit_used && order.credit_used > 0 &&
                            <h3>Đơn hàng được partner kích hoạt </h3>
                        }
                        {
                            (order.status === appConst.PAYMENT_STATUS_OPTIONS.PAID.value) &&
                            <button className="ladiui button primary open-modal" modal="modal-cancel-order" onClick={() => this.cancel(order)} style={{ marginLeft: '10px' }} >Hủy đơn hàng</button>
                        }

                    </div>
                    <div className="ladiui-modal-body">

                        <div className="order-box" style={{ width: '970px', margin: '15px' }}>
                            {/* <ul> */}
                            <div className="ladiui-row" style={{ height: '50px' }}>

                                <div className="col-50">
                                    <strong>Tổng tiền: </strong>
                                    {
                                        this.state.order.total && this.state.order.total.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                                    }
                                </div>


                                <div className="col-50">
                                    <strong>Giảm giá: </strong>
                                    {
                                        this.state.order.discount
                                    }
                                </div>
                            </div>
                            <div className="ladiui-row" style={{ height: '50px' }}>
                                <div className="col-50">
                                    <strong>Ghi chú: </strong>{this.state.order.note}
                                </div>
                                <div className="col-50">
                                    <strong>Trạng thái: </strong>{this.state.order.status}
                                </div>
                            </div>

                            {/* <li><strong>admin_id: ''</strong>{this.state.admin_id}</li> */}

                            {/* </ul> */}
                            {this.props.loading && <Spinner />}
                        </div>

                    </div>
                    <table className="ladiui table">
                        <thead>
                            <tr>
                                <th className="text-left">Store ID</th>
                                <th className="text-left">Store Name</th>
                                <th className="text-left">App</th>
                                <th className="text-left">Tên gói</th>
                                <th className="text-left">Tháng</th>

                                <th className="text-left">Tháng KM</th>

                                <th className="text-left">Tổng tiền</th>
                                <th className="text-right">Thời gian tạo</th>
                                <th className="text-right">Add-On</th>
                                {/* <th className="text-center">Discount Type</th>
                                <th className="text-center">Discount Value</th> */}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                _.map(details, detail => {
                                    let displayName = detail.pkg_name;
                                    if (detail.pkg_name == 'PREMIUM_5') {
                                        displayName = 'BUSSINESS_3';
                                    }
                                    if (detail.pkg_name == 'PREMIUM_10') {
                                        displayName = 'BUSSINESS_10';
                                    }
                                    if (detail.pkg_name == 'PREMIUM_20') {
                                        displayName = 'BUSSINESS_20';
                                    }
                                    displayName = displayName.replace('PREMIUM', 'BUSSINESS');
                                    if (detail.course_pkg_name && detail.course_pkg_name != '') {
                                        displayName = 'Khóa học:' + detail.course_pkg_name;
                                    }
                                    let strResourceLimits = '';
                                    let totalAddOn = 0;
                                    if (detail.resource_limits && Array.isArray(detail.resource_limits) && detail.resource_limits.length > 0) {
                                        _.map(detail.resource_limits, (resource) => {
                                            if (resource.total) {
                                                totalAddOn += resource.total;
                                            }
                                        })
                                    }
                                    return <tr key={detail._id}>
                                        <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{detail.store_id}</td>
                                        <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{detail.store_name}</td>
                                        <td>{appConst.APP[detail.pkg_type]}</td>
                                        <td>{displayName}</td>
                                        <td>{detail.pkg_month}</td>
                                        <td>{detail.addition_month}</td>
                                        <td>{detail.subtotal.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</td>
                                        <td className="text-right">{baseHelper.formatStrToDate(detail.created_at)}</td>
                                        <td style={{ whiteSpace: 'pre-line' }}>
                                            {(detail.resource_limits && Array.isArray(detail.resource_limits) && detail.resource_limits.length > 0) &&
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>App Code</th>
                                                            <th>AddOn</th>
                                                            <th>Limit</th>
                                                            <th>Số tháng</th>
                                                            <th>Tổng tiền</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {detail.resource_limits.map((resource, index) => {
                                                            return <tr key={index}>
                                                                <td>{resource.app_code}</td>
                                                                <td>{resource.resource_type}</td>
                                                                <td>{baseHelper.formatNumber(resource.limit_value)}</td>
                                                                <td>{resource.month}</td>
                                                                <td>{resource.total ? resource.total.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' }) : ''}</td>
                                                            </tr>
                                                        })}
                                                        <tr>
                                                            <td colSpan={3}></td>
                                                            <td><strong>Tổng tiền</strong></td>
                                                            <td>{totalAddOn.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>}
                                        </td>

                                        {/* <td>{detail.discount_type}</td>
                                        <td>{detail.discount_value}</td> */}
                                    </tr>
                                }
                                )
                            }
                        </tbody>
                    </table>

                    <div className="ladiui-modal-footer">

                        {/* {this.props.loading && <Spinner />} */}
                    </div>
                </div>
                <AddCommission
                    ref={this.formRef}
                    currentOrder={this.state.order}
                    affilate={affilate}
                />
                <Cancel
                    currentOrder={order}
                    currentStore={currentStore}
                />

            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getDetail: (order) => dispatch(orderActions.getDetail(order)),
        getListPackage: () => dispatch(storeActions.listPackages({}))
    }
}

const mapStateToProps = (state) => ({ ...state.order });

export default connect(mapStateToProps, mapDispatchToProps)(Detail);